import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("sidebar-top-nav__secondarynavregion-3mhsa7", {
  width: "100%"
});
const _staticStyles2 = _cssRef("sidebar-top-nav__wrapper-1p04bl", {
  display: "flex",
  width: "100%",
  justifyContent: "center",
  overflow: "visible",
  position: "relative",
  color: "var(--system-white)",
  zIndex: 250
});
const _staticStyles3 = _cssRef("sidebar-top-nav__cappedorangeband-22dyy3", {
  width: "100%",
  maxWidth: "1968px",
  backgroundColor: "var(--primary-orange-500)",
  position: "unset",
  padding: "0 65px",
  "@media (max-width: 1600px)": {
    padding: "0 32px"
  },
  "@media (max-width: 1440px)": {
    padding: "0 16px"
  }
});
const _staticStyles4 = _cssRef("sidebar-top-nav__containerflexarea-1hp1p9", {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "100%",
  gap: "34px",
  marginLeft: "auto",
  marginRight: "auto",
  padding: "5px 0",
  minHeight: "40px"
});
const _staticStyles5 = _cssRef("sidebar-top-nav__searchtypography-0bejix", {
  display: "inline-flex",
  gap: "5px",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer"
});
const _staticStyles6 = _cssRef("sidebar-top-nav__text-0tg18m", {
  textAlign: "center",
  display: "flex",
  justifyContent: "flex-end",
  padding: "16px 65px 0",
  "@media (max-width: 1600px)": {
    padding: "16px 32px 0"
  },
  "@media (max-width: 1440px)": {
    padding: "16px 16px 0"
  }
});
const _staticStyles7 = _cssRef("sidebar-top-nav__emergencycalltodayrow-2xlsxv", {
  "@media (max-width: 1300px)": {
    display: "none"
  }
});
const _staticStyles8 = _cssRef("sidebar-top-nav__navitemwrapper-2jxn20", {
  position: "static",
  display: "inline-block",
  zIndex: 1
});
const _staticStyles9 = _cssRef("sidebar-top-nav__navlink-10pdkg", {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  transition: "all 0.2s",
  backgroundColor: "transparent",
  color: "var(--system-white)",
  position: "relative",
  "&.active": {
    backgroundColor: "var(--system-white)",
    color: "var(--primary-orange-500)",
    padding: "4px 12px",
    borderRadius: "4px 4px 0 0",
    margin: "-4px -12px",
    transition: "none",
    "&::after": {
      content: "\"\"",
      position: "absolute",
      bottom: "-34px",
      left: 0,
      right: 0,
      height: "34px",
      backgroundColor: "var(--system-white)",
      transition: "none",
      pointerEvents: "auto",
      zIndex: 251
    }
  }
});
const _staticStyles0 = _cssRef("sidebar-top-nav__chevron-0tsae7", {
  display: "inline-flex",
  alignItems: "center",
  transition: "transform 0.2s",
  "&.open": {
    transform: "rotate(180deg)"
  }
});
const _staticStyles1 = _cssRef("sidebar-top-nav__dropdownpanel-2iw3p3", {
  position: "fixed",
  top: "45px",
  left: 0,
  width: "max-content",
  maxWidth: "1313px",
  zIndex: 9999,
  display: "none",
  pointerEvents: "none",
  "&.open": {
    display: "block"
  }
});
const _staticStyles10 = _cssRef("sidebar-top-nav__dropdowncontainer-2trdo2", {
  backgroundColor: "var(--system-white)",
  color: "var(--system-grey-900)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  paddingTop: "40px",
  paddingBottom: "40px",
  pointerEvents: "auto",
  "&.single-column": {
    paddingTop: "20px",
    paddingBottom: "20px"
  }
});
const _staticStyles11 = _cssRef("sidebar-top-nav__dropdowninner-1a8xgw", {
  paddingLeft: "40px",
  paddingRight: "40px",
  "@media (max-width: 1200px)": {
    paddingLeft: "24px",
    paddingRight: "24px"
  },
  "&.single-column": {
    paddingLeft: "20px",
    paddingRight: "20px"
  }
});
const _staticStyles12 = _cssRef("sidebar-top-nav__columnsgrid-1soyx2", {
  display: "flex",
  flexWrap: "nowrap",
  gap: "40px",
  listStyle: "none",
  margin: 0,
  padding: 0,
  width: "max-content",
  "@media (max-width: 1200px)": {
    gap: "24px"
  }
});
const _staticStyles13 = _cssRef("sidebar-top-nav__singlecolumn-1yqp45", {
  display: "flex",
  flexDirection: "column",
  gap: "0",
  maxWidth: "280px"
});
const _staticStyles14 = _cssRef("sidebar-top-nav__singlecolumnitem-15tqie", {
  paddingBottom: "16px",
  marginBottom: "16px",
  borderBottom: "1px solid var(--system-grey-200)",
  "&:last-child": {
    borderBottom: "none",
    marginBottom: 0,
    paddingBottom: 0
  }
});
const _staticStyles15 = _cssRef("sidebar-top-nav__groupitem-00gdw7", {
  flex: "0 0 auto"
});
const _staticStyles16 = _cssRef("sidebar-top-nav__groupwrapper-1slisk", {
  display: "flex",
  flexDirection: "column"
});
const _staticStyles17 = _cssRef("sidebar-top-nav__grouptitlebase-3tpde5", {
  fontFamily: "Graphie, sans-serif",
  fontWeight: "400",
  fontSize: "18px",
  lineHeight: "1.3",
  color: "var(--system-grey-800)",
  display: "block",
  marginBottom: 0,
  paddingBottom: "8px",
  whiteSpace: "nowrap",
  borderBottom: "1px solid var(--system-grey-200)"
});
const _staticStyles18 = _cssRef("sidebar-top-nav__grouptitle-1gj6x9", {
  textDecoration: "none",
  "&:hover": {
    color: "var(--primary-orange-500)",
    borderBottom: "1px solid var(--primary-orange-500)"
  }
});
const _staticStyles19 = _cssRef("sidebar-top-nav__grouptitlestatic-0x8iwn", {
  cursor: "default"
});
const _staticStyles20 = _cssRef("sidebar-top-nav__sublinkscontainer-3odf96", {
  marginLeft: 0,
  marginTop: "7px"
});
const _staticStyles21 = _cssRef("sidebar-top-nav__sublinkslist-2xaylx", {
  listStyle: "none",
  margin: 0,
  padding: 0,
  width: "100%"
});
const _staticStyles22 = _cssRef("sidebar-top-nav__sublinksitem-1ias04", {
  marginBottom: "4px"
});
const _staticStyles23 = _cssRef("sidebar-top-nav__linkitem-3m9r2m", {
  fontFamily: "Graphie, sans-serif",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "1.5",
  color: "var(--system-grey-700)",
  textDecoration: "none",
  display: "block",
  "&:hover": {
    color: "var(--primary-orange-500)"
  }
});
/**
 * Desktop orange secondary strip: Site Navigation `secondary` (national or microsite when mounted).
 * Data from `useSiteNavigation()` via NavigationProvider. Microsite: no Search; no national emergency CTA.
 */
import React from 'react';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';
import Container from '../../primitives/grid/container';
import Link from '../../primitives/link';
import { colors } from '../../primitives/colors';
import { useCtaProvider } from '../../../contexts/franchise/cta-provider';
import Typography from '../../primitives/typography';
import { useSiteSearch } from '../../site-search/site-search/provider';
import SearchIcon from './search-icon';
import type { SiteNavigationSecondary } from '../navigation/site-navigation-types';
import useSiteNavigation from '../use-site-navigation';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import { mirrorPrimaryMegaMenuHover, useNavigationContext } from '../../../contexts/navigation-context';
import { breakpoints, fontGraphie, rowPadding } from '../../primitives/tokens';
import hasNavigableHref from '../has-navigable-href';
import { EMERGENCY_TAGLINE, HEADER_CONTAINER_OUTER_MAX_PX, HEADER_DROPDOWN_MAX_WIDTH } from '../sidebar-header/utils';
const PRIMARY_NAV_SELECTOR = '[data-sidebar-primary-nav]';
const TOP_NAV_DROPDOWN_VIEWPORT_MARGIN = 16;

/** Compute fixed `left` so anchor (panel center or middle column) aligns under the trigger. */
const computeTopNavDropdownLeft = (triggerEl: HTMLElement, panelEl: HTMLElement, anchorEl: HTMLElement | null): number => {
  const triggerRect = triggerEl.getBoundingClientRect();
  const triggerCenterX = triggerRect.left + triggerRect.width / 2;
  const panelRect = panelEl.getBoundingClientRect();
  let anchorOffsetX: number;
  if (anchorEl) {
    const anchorRect = anchorEl.getBoundingClientRect();
    anchorOffsetX = anchorRect.left - panelRect.left + anchorRect.width / 2;
  } else {
    anchorOffsetX = panelRect.width / 2;
  }
  let left = triggerCenterX - anchorOffsetX;
  const maxLeft = window.innerWidth - panelRect.width - TOP_NAV_DROPDOWN_VIEWPORT_MARGIN;
  const minLeft = TOP_NAV_DROPDOWN_VIEWPORT_MARGIN;
  left = Math.max(minLeft, Math.min(left, maxLeft));
  return Math.round(left);
};
const PRIMARY_CHROME_SELECTOR = '[data-sidebar-primary-chrome]';
const isNodeUnderPrimaryBar = (node: Node | null, primaryNav: Element | null, primaryChrome: Element | null): boolean => {
  if (!(node instanceof Node)) return false;
  if (primaryNav?.contains(node)) return true;
  if (primaryChrome?.contains(node)) return true;
  return false;
};
const styles = {
  secondaryNavRegion: _staticStyles,
  wrapper: _staticStyles2,
  cappedOrangeBand: _staticStyles3,
  containerFlexArea: _staticStyles4,
  searchTypography: _staticStyles5,
  text: _staticStyles6,
  emergencyCallTodayRow: _staticStyles7,
  navItemWrapper: _staticStyles8,
  navLink: _staticStyles9,
  chevron: _staticStyles0,
  dropdownPanel: _staticStyles1,
  dropdownContainer: _staticStyles10,
  dropdownInner: _staticStyles11,
  columnsGrid: _staticStyles12,
  singleColumn: _staticStyles13,
  singleColumnItem: _staticStyles14,
  groupItem: _staticStyles15,
  groupWrapper: _staticStyles16,
  groupTitleBase: _staticStyles17,
  groupTitle: _staticStyles18,
  groupTitleStatic: _staticStyles19,
  subLinksContainer: _staticStyles20,
  subLinksList: _staticStyles21,
  subLinksItem: _staticStyles22,
  linkItem: _staticStyles23
};
const ChevronDown = (): JSX.Element => <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>;
interface NavItemDropdownProps {
  section: SiteNavigationSecondary;
  isOpen: boolean;
  onMouseEnter: () => void;
}
const NavItemDropdown = ({
  section,
  isOpen,
  onMouseEnter
}: NavItemDropdownProps): JSX.Element | null => {
  const navLinkItem = {
    title: section.title ?? '',
    href: section.link ?? undefined
  };
  const allGroups = (section.items ?? []).filter(Boolean).map(row => ({
    groupLink: {
      title: row?.title ?? '',
      href: row?.link ?? undefined
    },
    subgroup: [{
      links: (row?.items ?? []).filter(Boolean).map(leaf => ({
        link: {
          title: leaf?.title ?? '',
          href: leaf?.link ?? ''
        }
      }))
    }]
  })).filter(g => Boolean(g.groupLink?.title));

  // Previously L3-only: dropdown never opened when every L2 row had only a direct link (`items: []`).
  // Show the panel whenever the section has any L2 rows under `secondary` (About Us columns, etc.).
  const hasDropdownContent = allGroups.length > 0;
  const isMultiColumn = allGroups.length > 2;
  const anchorColumnIndex = isMultiColumn ? Math.floor((allGroups.length - 1) / 2) : -1;
  const triggerRef = React.useRef<HTMLDivElement>(null);
  const dropdownPanelRef = React.useRef<HTMLDivElement>(null);
  React.useLayoutEffect(() => {
    if (!isOpen || !triggerRef.current || !dropdownPanelRef.current) {
      return;
    }
    const anchorEl = isMultiColumn ? dropdownPanelRef.current.querySelector('[data-top-nav-anchor-column]') : null;
    const left = computeTopNavDropdownLeft(triggerRef.current, dropdownPanelRef.current, anchorEl instanceof HTMLElement ? anchorEl : null);
    dropdownPanelRef.current.style.left = `${left}px`;
  }, [isOpen, isMultiColumn, allGroups.length]);
  if (!navLinkItem?.title) return null;
  return <div {..._mergeProps({
    ref: triggerRef,
    css: styles.navItemWrapper,
    onMouseEnter: onMouseEnter,
    "data-top-nav-item": true
  })}>
            {navLinkItem.href && !hasDropdownContent ? <Typography {..._mergeComponentProps({
      as: Link,
      to: navLinkItem.href,
      fontSize: {
        dt: 'base'
      },
      fontWeight: "medium",
      css: styles.navLink
    })}>
                    {navLinkItem.title}
                </Typography> : <Typography {..._mergeComponentProps({
      as: "span",
      fontSize: {
        dt: 'base'
      },
      fontWeight: "medium",
      css: [styles.navLink, !navLinkItem.href && styles.groupTitleStatic],
      className: isOpen ? 'active' : ''
    })}>
                    {navLinkItem.title}
                    {hasDropdownContent && <span {..._mergeProps({
        css: styles.chevron,
        className: isOpen ? 'open' : ''
      })}>
                            <ChevronDown />
                        </span>}
                </Typography>}

            {hasDropdownContent && isOpen && <div {..._mergeProps({
      ref: dropdownPanelRef,
      css: styles.dropdownPanel,
      className: `open ${isMultiColumn ? '' : 'single-column'}`,
      "data-top-nav-dropdown": true
    })}>
                    <div {..._mergeProps({
        css: styles.dropdownContainer,
        className: isMultiColumn ? '' : 'single-column'
      })}>
                        <div {..._mergeProps({
          css: styles.dropdownInner,
          className: isMultiColumn ? '' : 'single-column'
        })}>
                            {/* Check if this is a multi-column layout (About) or single column (Careers) */}
                            {isMultiColumn ?
          // Multi-column layout for About
          <ul {..._mergeProps({
            css: styles.columnsGrid
          })}>
                                    {allGroups.map((group, groupIndex) => {
              const groupLink = group?.groupLink;
              const subgroups = group?.subgroup || [];
              const groupKey = `group-${navLinkItem.title}-${groupLink?.title || groupIndex}`;
              const hasSubLinks = subgroups.length > 0 && subgroups.some(sg => sg?.links && sg.links.length > 0);
              return <div {..._mergeProps({
                key: groupKey,
                css: styles.groupItem
              }, groupIndex === anchorColumnIndex ? {
                'data-top-nav-anchor-column': true
              } : {})}>
                                                <div {..._mergeProps({
                  css: styles.groupWrapper
                })}>
                                                    {groupLink?.title && (hasNavigableHref(groupLink.href) ? <Link {..._mergeComponentProps({
                    to: groupLink.href as string,
                    css: [styles.groupTitleBase, styles.groupTitle],
                    role: "group"
                  })}>
                                                                {groupLink.title}
                                                            </Link> : <div {..._mergeProps({
                    css: [styles.groupTitleBase, styles.groupTitleStatic]
                  })}>{groupLink.title}</div>)}

                                                    {hasSubLinks && <div {..._mergeProps({
                    css: styles.subLinksContainer
                  })}>
                                                            <ul {..._mergeProps({
                      css: styles.subLinksList
                    })}>
                                                                {subgroups.map((subgroup, subgroupIndex) => {
                        const links = subgroup?.links || [];
                        const subgroupKey = `${groupKey}-subgroup-${subgroupIndex}`;
                        return <React.Fragment key={subgroupKey}>
                                                                            {links.map(linkItem => {
                            const link = linkItem?.link;
                            if (!link?.title || !link?.href) return null;
                            return <li {..._mergeProps({
                              key: `${subgroupKey}-link-${link.href}`,
                              css: styles.subLinksItem
                            })}>
                                                                                        <Link {..._mergeComponentProps({
                                to: link.href,
                                css: styles.linkItem
                              })}>
                                                                                            {link.title}
                                                                                        </Link>
                                                                                    </li>;
                          })}
                                                                        </React.Fragment>;
                      })}
                                                            </ul>
                                                        </div>}
                                                </div>
                                            </div>;
            })}
                                </ul> :
          // Single column layout for Careers
          <div {..._mergeProps({
            css: styles.singleColumn
          })}>
                                    {allGroups.map((group, groupIndex) => {
              const groupLink = group?.groupLink;
              const subgroups = group?.subgroup || [];
              const groupKey = `group-${navLinkItem.title}-${groupLink?.title || groupIndex}`;
              const hasSubLinks = subgroups.length > 0 && subgroups.some(sg => sg?.links && sg.links.length > 0);
              return <div {..._mergeProps({
                key: groupKey,
                css: styles.singleColumnItem
              })}>
                                                {groupLink?.title && (hasNavigableHref(groupLink.href) ? <Link {..._mergeComponentProps({
                  to: groupLink.href as string,
                  css: [styles.groupTitleBase, styles.groupTitle]
                })}>
                                                            {groupLink.title}
                                                        </Link> : <div {..._mergeProps({
                  css: [styles.groupTitleBase, styles.groupTitleStatic]
                })}>{groupLink.title}</div>)}

                                                {hasSubLinks && <div {..._mergeProps({
                  css: styles.subLinksContainer
                })}>
                                                        <ul {..._mergeProps({
                    css: styles.subLinksList
                  })}>
                                                            {subgroups.map((subgroup, subgroupIndex) => {
                      const links = subgroup?.links || [];
                      const subgroupKey = `${groupKey}-subgroup-${subgroupIndex}`;
                      return <React.Fragment key={subgroupKey}>
                                                                        {links.map(linkItem => {
                          const link = linkItem?.link;
                          if (!link?.title || !link?.href) return null;
                          return <li {..._mergeProps({
                            key: `${subgroupKey}-link-${link.href}`,
                            css: styles.subLinksItem
                          })}>
                                                                                    <Link {..._mergeComponentProps({
                              to: link.href,
                              css: styles.linkItem
                            })}>
                                                                                        {link.title}
                                                                                    </Link>
                                                                                </li>;
                        })}
                                                                    </React.Fragment>;
                    })}
                                                        </ul>
                                                    </div>}
                                            </div>;
            })}
                                </div>}
                        </div>
                    </div>
                </div>}
        </div>;
};
const SidebarTopNav = (): JSX.Element | null => {
  const location = useLocation();
  const {
    isMicrosite
  } = useMicrosite();
  const {
    setVisible
  } = useSiteSearch();
  const corporateNavData = useSiteNavigation()?.secondary ?? null;
  const [openDropdown, setOpenDropdown] = React.useState<string | null>(null);
  const {
    registerSecondaryTopNavClose,
    dropdownDelay,
    dismissPrimaryMegaMenu,
    dismissSecondaryTopNavDropdown
  } = useNavigationContext();
  const {
    hideNationalCallCenter,
    hideFranchiseLink
  } = useCtaProvider();

  // Close dropdown on route changes
  React.useEffect(() => {
    setOpenDropdown(null);
  }, [location.pathname]);

  // Register close handler for orange-strip dropdown (secondary top nav).
  React.useEffect(() => {
    const closeTopNav = (): void => {
      setOpenDropdown(null);
      dropdownDelay.cancelDelay();
    };
    registerSecondaryTopNavClose(closeTopNav);
  }, [registerSecondaryTopNavClose, dropdownDelay]);

  // Handle all click and scroll events that should close the dropdown
  React.useEffect(() => {
    const handleClick = (event: MouseEvent): void => {
      const target = event.target as HTMLElement;
      const clickedLink = target.closest('a[href]');
      const isInTopNavDropdown = clickedLink?.closest('[data-top-nav-dropdown]');
      const isInsideDropdown = target.closest('[data-top-nav-dropdown]');
      const isInsideNavItem = target.closest('[data-top-nav-item]');

      // Close immediately if clicking a link in the dropdown
      if (isInTopNavDropdown && openDropdown) {
        setOpenDropdown(null);
        dropdownDelay.cancelDelay();
      } else if (openDropdown && !isInsideDropdown && !isInsideNavItem) {
        // Close if clicking outside the dropdown (but not on nav items)
        setOpenDropdown(null);
        dropdownDelay.cancelDelay();
      }
    };
    const handleScroll = (): void => {
      if (openDropdown) {
        setOpenDropdown(null);
        dropdownDelay.cancelDelay();
      }
    };

    // Use capture phase for clicks to ensure we intercept before navigation
    document.addEventListener('click', handleClick, true);
    window.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('click', handleClick, true);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [openDropdown, dropdownDelay]);
  const secondarySections = (corporateNavData ?? []).filter((s): s is SiteNavigationSecondary => Boolean(s));
  const dismissMegaMenuIfEnteredFromOutside = React.useCallback((e: React.MouseEvent<HTMLDivElement> | React.FocusEvent<HTMLDivElement>) => {
    const {
      relatedTarget,
      currentTarget
    } = e;
    if (relatedTarget instanceof Node && currentTarget.contains(relatedTarget)) {
      return;
    }
    dismissPrimaryMegaMenu();
  }, [dismissPrimaryMegaMenu]);

  /** Same delay-based close as primary mega-menu root (`DROPDOWN_CLOSE_DELAY_MS`), covering the whole strip + fixed dropdown. */
  const handleSecondaryRegionMouseEnter = React.useCallback(() => {
    dropdownDelay.cancelDelay();
  }, [dropdownDelay]);
  const secondaryRegionRef = React.useRef<HTMLDivElement>(null);

  // `mouseout` bubbles and reliably detects leaving the region (including fixed dropdown descendants);
  // React `mouseleave` on the wrapper was not firing consistently in this layout.
  React.useEffect(() => {
    const el = secondaryRegionRef.current;
    if (!el) return undefined;
    const onMouseOut = (e: MouseEvent): void => {
      const next = e.relatedTarget;
      if (next instanceof Node && el.contains(next)) {
        return;
      }
      const primaryNav = document.querySelector(PRIMARY_NAV_SELECTOR);
      const primaryChrome = document.querySelector(PRIMARY_CHROME_SELECTOR);
      if (isNodeUnderPrimaryBar(next instanceof Node ? next : null, primaryNav, primaryChrome)) {
        dismissSecondaryTopNavDropdown();
        mirrorPrimaryMegaMenuHover(next as Node);
        return;
      }

      // Transparent fixed dropdown / fast diagonal moves often yield null or unrelated relatedTarget;
      // use the pointer position so the logo / left side of the primary bar still counts.
      if (Number.isFinite(e.clientX) && Number.isFinite(e.clientY)) {
        const under = document.elementFromPoint(e.clientX, e.clientY);
        if (isNodeUnderPrimaryBar(under, primaryNav, primaryChrome)) {
          dismissSecondaryTopNavDropdown();
          mirrorPrimaryMegaMenuHover(under as Node);
          return;
        }
      }
      dropdownDelay.handleMouseLeave();
    };
    el.addEventListener('mouseout', onMouseOut);
    return () => {
      el.removeEventListener('mouseout', onMouseOut);
    };
  }, [dismissSecondaryTopNavDropdown, dropdownDelay]);
  if (isMicrosite && secondarySections.length === 0) {
    return null;
  }
  return <div {..._mergeProps({
    ref: secondaryRegionRef,
    css: styles.secondaryNavRegion,
    "data-sidebar-secondary-nav": true,
    onFocus: dismissMegaMenuIfEnteredFromOutside,
    onMouseOver: dismissMegaMenuIfEnteredFromOutside,
    onMouseEnter: handleSecondaryRegionMouseEnter
  })}>
            <div {..._mergeProps({
      css: styles.wrapper
    })}>
                <div {..._mergeProps({
        css: styles.cappedOrangeBand
      })}>
                    <Container>
                        <div {..._mergeProps({
            css: styles.containerFlexArea
          })}>
                            {secondarySections.map(section => {
              const navTitle = section?.title ?? '';
              if (!navTitle) return null;
              return <NavItemDropdown key={`nav-item-${navTitle}`} section={section} isOpen={openDropdown === navTitle} onMouseEnter={() => {
                dropdownDelay.cancelDelay();
                setOpenDropdown(navTitle);
              }} />;
            })}

                            {!isMicrosite && <Typography {..._mergeComponentProps({
              fontSize: {
                dt: 'base'
              },
              fontWeight: "medium",
              as: "button",
              onClick: () => {
                setVisible(true);
              },
              css: styles.searchTypography
            })}>
                                    <SearchIcon />
                                    Search
                                </Typography>}
                        </div>
                    </Container>
                </div>
            </div>

            {!isMicrosite && !hideFranchiseLink && !hideNationalCallCenter && <Container {..._mergeComponentProps({
      css: styles.emergencyCallTodayRow
    })}>
                    <Typography {..._mergeComponentProps({
        color: "primaryOrange",
        fontSize: {
          dt: 'lg'
        },
        css: styles.text
      })}>
                        {EMERGENCY_TAGLINE}
                    </Typography>
                </Container>}
        </div>;
};
export default SidebarTopNav;